import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar.js';
import './COEForm.css';
import header_en from './assets/images/header_en.png';
import header_ms from './assets/images/header_ms.png';
import header_zh from './assets/images/header_zh.png';

function COEForm() {
    const moment = require('moment-timezone');
    const location = useLocation();
    const navigate = useNavigate();
    const { language = 'en' } = location.state || {};

    const [questionList, setQuestionList] = useState([]);
    const [surveyID, setSurveyID] = useState([]);
    const [formValues, setFormValues] = useState({});

    // Import images dynamically
    const icons = Array.from({ length: 13 }, (_, i) => require(`./assets/icons/${i + 1}.png`));

    const headerImages = {
        en: header_en,
        ms: header_ms,
        zh: header_zh
    };

    const buttonText = {
        en: { previous: 'Previous', submit: 'Submit' },
        ms: { previous: 'Sebelum', submit: 'Hantar' },
        zh: { previous: '上一页', submit: '提交' }
    };

    useEffect(() => {
        const fetchQuestion = async () => {
            const survey_id = "6796f1781558863077771c1d";

            const response = await fetch(
                `${process.env.REACT_APP_AI_FORM_SERVER}/api/getQuestion?_=${new Date().getTime()}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ survey_id }),
                }
            );


            const jsonData = await response.json();

            setSurveyID(jsonData[0]?.survey_id);
            setQuestionList(jsonData[0]?.details || []);
        };

        fetchQuestion();
    }, []);


    useEffect(() => {
        const initialValues = {};
        questionList.forEach(question => {
            const key = question.questions?.[language];

            if (question.qtype === "checkbox_multiple") {
                initialValues[key] = []; // Empty array for multiple checkboxes
            } else {
                initialValues[key] = ""; // Default empty string
            }
        });

        setFormValues(initialValues);


        console.log("!!!!!!!!!!!!!!!!!!!HI")
        console.log(formValues)


    }, [questionList]);

    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormValues(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value ?? ''
        }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault(); 


        const invalidCheckboxes = questionList.some(question => {
            if (question.qtype === 'checkbox_single' || question.qtype === 'checkbox_multiple') {
                const questionKey = question?.questions?.[language];

                // Ensure questionKey is valid
                if (!questionKey) {
                    console.log("Invalid question key:", question);
                    return false; // Skip this question if no valid key
                }

                const selectedValues = formValues[questionKey];
         //       console.log(`Checking question: ${questionKey}`, selectedValues);

                return question.required && (!selectedValues || selectedValues.length === 0);
            }
            return false;
        });

        if (invalidCheckboxes) {
            alert("Please select at least one option for required checkboxes.");
            return;
        }

 
        const confirmed = window.confirm("Are you sure you want to submit the form?");
        if (confirmed) {

  
          
           try {
                const response = await fetch(`${process.env.REACT_APP_AI_FORM_SERVER}/api/formSubmit`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        survey_id: surveyID,
                        language: language,
                        response: formValues, 
                        submissionDate : moment().tz('Asia/Kuala_Lumpur').format()
                    }),
                })
               const data = await response.json();

               if (data.success) {
                   window.alert('Success.');
                   window.location.href = '/formSubmit'; 
               } else {
                   window.alert('Failed to submit form, please try again.');
               }
           } catch (error) {
               console.log('Error submitting form:', error);
               window.alert('Failed to submit form, please try again.');
           }


        }
    };


    const groupedQuestions = questionList.reduce((acc, question) => {
        const groupName = question.group?.[language] || 'Ungrouped';
        if (!acc[groupName]) acc[groupName] = [];
        acc[groupName].push(question);
        return acc;
    }, {});


    return (
        <div>
            <Navbar currentPage="PickupForm" />
            <div className="form-container">
                <br /><br /><br />

                <div className="header-container">
                    <img src={headerImages[language]} alt="Header" className="header-image" />
                </div>

                <form onSubmit={handleFormSubmit}>
                    <span style={{ color: 'red', fontSize: '0.8em' }}>* is a required field</span>
                    <hr />

                    {Object.entries(groupedQuestions).map(([groupName, questions], groupIndex) => (
                        <div key={groupIndex} style={{ marginBottom: "20px" }}>
                            <div
                                style={{
                                    backgroundColor: "#E6F2F2",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    marginBottom: "10px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px", // Ensures uniform spacing
                                }}
                            >
                                <img
                                    src={icons[groupIndex % 13]}
                                    alt={`icon-${groupIndex}`}
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        display: "block", // Removes extra spacing
                                        objectFit: "contain", // Ensures no background fill
                                        backgroundColor: "transparent",
                                    }}
                                />
                                <h3 style={{ margin: 0 }}>{groupName}</h3>
                            </div>

                            {questions.map((question, index) => (
                                <div key={index} style={{ marginBottom: '15px' }}>
                                    <p>
                                        {question.questions?.[language]}{' '}
                                        {question.required && <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>}
                                    </p>

                                    {question.qtype === 'text' && (
                                        <input
                                            name={question.questions?.[language]}
                                            value={formValues[question.questions?.[language]] || ''}
                                            onChange={handleFormChange}
                                            required={question.required}
                                            type="text"
                                            style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '5px' }}
                                        />
                                    )}

                                    {(question.qtype === 'checkbox_single' || question.qtype === 'checkbox_multiple') && (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                            {question.options.map((option, idx) => (
                                                <label key={idx} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <input
                                                        type="checkbox"
                                                        name={question.questions?.[language]} 
                                                        value={option[language]}
                                                   
                                                        checked={
                                                            question.qtype === 'checkbox_single'
                                                                ? formValues[question.questions?.[language]] === option[language] 
                                                                : formValues[question.questions?.[language]]?.includes(option[language]) || false
                                                        }
                                                        onChange={(e) => {
                                                            if (question.qtype === 'checkbox_single') {
                                                    
                                                                setFormValues(prev => ({
                                                                    ...prev,
                                                                    [question.questions?.[language]]: e.target.checked ? option[language] : '', 
                                                                }));
                                                            } else {
                                                         
                                                                const checkedOptions = formValues[question.questions?.[language]] || [];
                                                                if (e.target.checked) {
                                                                    setFormValues(prev => ({
                                                                        ...prev,
                                                                        [question.questions?.[language]]: [...checkedOptions, option[language]],
                                                                    }));
                                                                } else {
                                                                    setFormValues(prev => ({
                                                                        ...prev,
                                                                        [question.questions?.[language]]: checkedOptions.filter(opt => opt !== option[language]),
                                                                    }));
                                                                }
                                                            }
                                                        }}
                                                        style={{ width: '14px', height: '14px' }}
                                                    />
                                                    {option[language]}
                                                </label>
                                            ))}
                                        </div>
                                    )}



                                </div>
                            ))}
                        </div>
                    ))}

                
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '20px' }}>
                        <input
                            type="button"
                            className="submitButton previousButton"
                            value={buttonText[language].previous}
                            style={{ marginRight: '100px' }}
                            onClick={() => navigate(-1)}
                        />
                        <input type="submit" className="submitButton submitButton" value={buttonText[language].submit} />
                    </div>
                </form>
            </div>
        </div>
    );
}

export default COEForm;
